import {Box} from "@mui/material";
import {FC} from "react";
import {makeStyles} from "tss-react/mui";
import {ForgottenPasswordForm} from "@buildwitt/shapeshift-common/v1/forgotten-password";

const logo = "/logo.svg"

const useStyles = makeStyles()((theme) => ({
	forgottenPasswordPage:{
		backgroundColor: theme.palette.background.default,
		minHeight: "100%",
		width: "100%",
		boxSizing: "border-box",
		display: "flex",
		alignItems: "center",
		flexDirection: "column",
		[theme.breakpoints.down("sm")]: {
			backgroundColor: theme.palette.background.paper
		}
	},
	container: {
		marginTop: "15px",
		margin: "auto",
		display: "flex",
		flexDirection: "column",
		[theme.breakpoints.down("sm")]: {
			flexDirection: "column-reverse"
		}
	},
	imgContainer: {
		margin: "40px 0",
		textAlign: "center",
		width: "100%",
		[theme.breakpoints.down("sm")]: {
			margin: "30px 0"
		},
		"& img": {
			[theme.breakpoints.down("sm")]: {
				width: "149px"
			}
		}
	},
	forgottenPasswordForm: {
		marginTop: "15px"
	}
}));

export const ForgottenPasswordPage: FC = () => {
	const {classes} = useStyles();

	return (
		<Box className={classes.forgottenPasswordPage}>
			<Box className={classes.container}>
				<ForgottenPasswordForm
					className={classes.forgottenPasswordForm}
					title="Password Recovery"
				/>
				<div className={classes.imgContainer}>
					<img src={logo} />
				</div>
			</Box>
		</Box>
	);
}